import { FC } from 'react';
import { VictoryPie } from 'victory';
import styles from './pieChart.module.scss';

const PieChart: FC<{
    percentage: number;
    showPercentage?: boolean;
    size?: number;
    position?: string;
}> = ({
    percentage,
    showPercentage = true,
    size = 50,
    position = 'absolute'
}: {
    percentage: number;
    showPercentage?: boolean;
    size?: number;
    position?: string;
}) => {
    return (
        <div className={styles['pie-circle-chart']}>
            <div
                className={styles.main}
                style={{ width: `${size / 16}rem`, height: `${size / 16}rem`, '--position': position } as any}
            >
                {showPercentage && <div className={styles['fixed-center']}>{Math.trunc(percentage)}%</div>}
            </div>

            <div className={styles['progress-wrapper']}>
                <svg viewBox="0 0 400 400" width="100%" height="100%">
                    <VictoryPie
                        standalone={false}
                        animate={{ duration: 1000 }}
                        width={400}
                        height={400}
                        data={[
                            { x: 1, y: percentage },
                            { x: 2, y: 100 - percentage }
                        ]}
                        innerRadius={120}
                        cornerRadius={25}
                        labels={() => null}
                        style={{
                            data: {
                                fill: ({ datum }) => {
                                    const color = '#FB86B6';
                                    return datum.x === 1 ? color : 'transparent';
                                }
                            }
                        }}
                    />
                </svg>
            </div>
        </div>
    );
};

export default PieChart;
